import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';
import moment from 'moment';
import swal from 'sweetalert';
import "../../componentes/Plantillas/Estilos.css";
import "../../componentes/NotaCreditoDebito/botonesaccion.css";
import { convertStrToJson } from '../../Global';
import { printA4Servicios } from '../../helpers/A4Servicios';

const ListadoComprobantes = () => {
    const history = useHistory();
    const [comprobantes, setComprobantes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [fechaFin, setFechaFin] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    const obtenerComprobantes = async () => {
        setLoading(true);
        try {
            const response = await fetch(`/api/servicios/comprobantes?inicio=${fechaInicio}&fin=${fechaFin}`);
            if (!response.ok) {
                throw new Error('Error al obtener comprobantes');
            }
            const data = await response.json();
            const lista = data.comprobantes || data || [];
            setComprobantes(Array.isArray(lista) ? lista : []);
        } catch (error) {
            console.error("Error obteniendo comprobantes:", error);
            setComprobantes([]);
        } finally {
            setFechaInicio(moment(fechaInicio).format('YYYY-MM-DD'));
            setFechaFin(moment(fechaFin).format('YYYY-MM-DD'));
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerComprobantes();
    }, []);

    const handleFiltrar = () => {
        obtenerComprobantes();
    };

    const handleEmitirComprobante = () => {
        history.push('/servicios/emitir-comprobante');
    };

    const verDetalle = (comprobante) => {
        console.log("Ver detalle", comprobante);
    };

    const handleEnviarOperador = async (idServicioVenta) => {
        setLoading(true);
        try {
            const response = await fetch(`/api/servicios/ce/${idServicioVenta}`);
            const rpta = await response.json();
            if (!rpta.ok) {
                swal({
                    title: 'Error de Envío ',
                    text: rpta.msg || `El Comprobante Electrónico no fué enviado al Operador`,
                    icon: 'warning'
                })
            } else {
                swal({
                    title: 'Envío Satisfactorio...! ',
                    text: `El Comprobante fué enviado al Operador verifique el Código de Respuesta`,
                    icon: 'success'
                })
            }
            obtenerComprobantes();
        } catch (error) {
            console.error("Error enviando a operador:", error);
            swal("Error", "Ocurrió un error al intentar enviar el comprobante", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleImprimir = async (idServicioVenta) => {
        setLoading(true);
        try {
            const response = await fetch(`/api/servicios/detalle/${idServicioVenta}`);
            if (!response.ok) {
                throw new Error('Error al obtener detalles del comprobante');
            }
            const data = await response.json();
            await printA4Servicios(data);
        } catch (error) {
            console.error("Error imprimiendo comprobante:", error);
            swal("Error", "Ocurrió un error al intentar imprimir el comprobante", "error");
        } finally {
            setLoading(false);
        }
    };

    const styleCalendar = {
        border: "0.5px solid #acacac",
        borderRadius: "25px",
        outline: "none",
        flexBasis: "50%",
        alignSelf: "center"
    };

    const columnas = [
        {
            Header: "Opciones",
            id: "IdServicioVenta",
            width: 90,
            className: "ancho-prueba",
            filterable: false,
            accessor: d => d.IdServicioVenta,
            Cell: f => {
                let resEnvioSunat = convertStrToJson(f.original.RespuestaSunat);
                const rv = f.original;

                const oldXmlUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${rv.RucEmisor}/xml/${rv.CodigoTipoComprobante}/${rv.RucEmisor}-${rv.CodigoTipoComprobante}-${rv.Serie}-${rv.NumeroComprobante}.xml`;
                const oldCdrUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${rv.RucEmisor}/xml/${rv.CodigoTipoComprobante}/R-${rv.RucEmisor}-${rv.CodigoTipoComprobante}-${rv.Serie}-${rv.NumeroComprobante}.zip`;

                let xml = (resEnvioSunat.xmlFirmado && resEnvioSunat.xmlFirmado.length ? resEnvioSunat.xmlFirmado : oldXmlUrl).replace('http', 'https');
                let cdrZip = (resEnvioSunat.cdrZip && resEnvioSunat.cdrZip.length ? resEnvioSunat.cdrZip : oldCdrUrl).replace('http', 'https');

                return (
                    <div align="center">
                        <div className="dropdown">
                            <button className="btn options-ventas" type="button"
                                    data-toggle="dropdown" aria-expanded="false">
                            </button>
                            <div className="dropdown-menu py-1">
                                <div className="dropdown-item px-2">
                                    <button
                                        className="btn btn-primary btn-sm btn-block font-weight-bold"
                                        onClick={() => verDetalle(f.original)}
                                        title="Ver detalle de Servicio"
                                    >
                                        Ver detalle
                                    </button>
                                </div>
                                <div className="dropdown-item px-2">
                                    <button
                                        className="btn btn-secondary btn-sm btn-block font-weight-bold"
                                        onClick={() => handleImprimir(f.original.IdServicioVenta)}
                                        title="Imprimir Comprobante"
                                    >
                                        Imprimir
                                    </button>
                                </div>
                                <div className="dropdown-item px-2">
                                    <button
                                        className="btn btn-info btn-sm btn-block font-weight-bold"
                                        disabled={f.original.EstadoSUNAT === "ACEPTADO" || f.original.Estado === "ANULADA"}
                                        onClick={() => handleEnviarOperador(f.original.IdServicioVenta)}
                                        title="Enviar a Operador"
                                    >
                                        Enviar a operador
                                    </button>
                                </div>
                                {xml ? (
                                    <div className="dropdown-item px-2">
                                        <a
                                            className="btn btn-success btn-sm btn-block font-weight-bold"
                                            target="blank"
                                            title={`Descargar XML`}
                                            href={xml}
                                        >
                                            Descargar XML
                                        </a>
                                    </div>
                                ) : null}
                                {cdrZip ? (
                                    <div className="dropdown-item px-2">
                                        <a
                                            className="btn btn-success btn-sm btn-block font-weight-bold"
                                            target="blank"
                                            href={cdrZip}
                                            title="Descargar CDR"
                                        >
                                            Descargar CDR
                                        </a>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                );
            },
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "EstadoCE",
            id: "EstadoSUNAT",
            width: 100,
            accessor: d => d.EstadoSUNAT,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["EstadoSUNAT"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Serie",
            id: "Serie",
            width: 70,
            accessor: d => d.Serie,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["Serie"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Nro Comprobante",
            id: "NumeroComprobante",
            width: 110,
            accessor: d => d.NumeroComprobante,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["NumeroComprobante"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Fecha",
            id: "FechaEmision",
            width: 100,
            accessor: d => moment(d.FechaEmision).format("DD-MM-YYYY"),
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["FechaEmision"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "RUC",
            id: "NroTipoDocumento",
            width: 120,
            accessor: d => d.NroTipoDocumento,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["NroTipoDocumento"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Cliente",
            id: "RazonSocial",
            width: 290,
            accessor: d => d.RazonSocial,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["RazonSocial"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Tipo Comprobante",
            id: "TipoComprobante",
            width: 130,
            accessor: d => d.TipoComprobante,
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["TipoComprobante"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Total",
            id: "Total",
            width: 100,
            accessor: d => Number(d.Total).toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["Total"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    textAlign: "right",
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Gravadas",
            id: "Gravadas",
            width: 100,
            accessor: d => Number(d.Gravadas).toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["Gravadas"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    textAlign: "right",
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Inafectas",
            id: "Inafectas",
            width: 100,
            accessor: d => Number(d.Inafectas).toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["Inafectas"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    textAlign: "right",
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "Exoneradas",
            id: "Exoneradas",
            width: 100,
            accessor: d => Number(d.Exoneradas).toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["Exoneradas"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    textAlign: "right",
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "IGV",
            id: "IGV",
            width: 100,
            accessor: d => Number(d.IGV).toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["IGV"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    textAlign: "right",
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        },
        {
            Header: "ICBPER",
            id: "ICBPER",
            width: 100,
            accessor: d => Number(d.ICBPER).toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["ICBPER"] }),
            filterAll: true,
            getProps: (state, rowInfo) => ({
                style: {
                    textAlign: "right",
                    background: rowInfo && rowInfo.row.Estado === "ANULADA" ? "#ffcccc" : null
                }
            })
        }
    ];

    return (
        <>
            <div className='ventas-fpay-section'>
                <div className="pt-3">
                    <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2 mt-3">
                        <span className="align-self-center letra-fecha-fpay">Desde: </span>
                        <input
                            type="date"
                            onChange={(e) => setFechaInicio(e.target.value)}
                            value={fechaInicio}
                            className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            style={styleCalendar}
                        />
                        <span className="align-self-center letra-fecha-fpay">Hasta: </span>
                        <input
                            type="date"
                            onChange={(e) => setFechaFin(e.target.value)}
                            value={fechaFin}
                            className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                            style={styleCalendar}
                        />
                    </div>

                    <div className="container">
                        <div className="col-12 mt-4 no-pad">
                            <div className="d-flex justify-content-end">
                                <div className='row justify-content-end ml-0 mr-0'>
                                    <div className='ml-3'>
                                        <div className="seccion-btn-verde-mfp">
                                            <button
                                                className="btn btn-outline-primary btn-verde-mfp mr-3"
                                                type="button"
                                                onClick={handleEmitirComprobante}
                                            >
                                                Emitir Comprobante
                                            </button>
                                            <button
                                                onClick={handleFiltrar}
                                                className="btn btn-outline-primary btn-verde-mfp"
                                                disabled={loading}
                                            >
                                                {loading ? "Cargando..." : "Generar"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-3">
                            <ReactTable
                                id="servicios"
                                data={comprobantes}
                                filterable
                                defaultFilterMethod={(filter, row) =>
                                    String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                }
                                columns={[{ columns: columnas }]}
                                defaultPageSize={10}
                                className="-striped -highlight"
                                previousText='Anterior'
                                nextText='Siguiente'
                                loadingText='Cargando...'
                                noDataText='No se encontraron registros'
                                pageText='Página'
                                ofText='de'
                                rowsText='filas'
                                style={{
                                    width: "100%",
                                    fontSize: "15px"
                                }}
                                pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ListadoComprobantes;
